import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-latex-grammar-checker',
  templateUrl: './latex-grammar-checker.component.html',
  styleUrls: ['./latex-grammar-checker.component.scss']
})
export class LatexGrammarCheckerComponent implements OnInit, AfterViewInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('LaTeX 문법 검사기 | 교정 LaTeX 파일| Trinka AI 기반');
    this.metaTagService.updateTag({ name: 'description', content: "LaTeX용 Trinka 교정 파일은 클릭 한 번으로 LaTeX 파일의 문법을 검사할 수 있는 솔루션으로, 자동 문법 검사 기능으로 시간을 절약할 수 있습니다." });
    this.metaTagService.updateTag({ property: 'og:title', content: 'LaTeX 문법 검사기 | 교정 LaTeX 파일| Trinka AI 기반' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'LaTeX용 Trinka 교정 파일은 클릭 한 번으로 LaTeX 파일의 문법을 검사할 수 있는 솔루션으로, 자동 문법 검사 기능으로 시간을 절약할 수 있습니다.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/features/latex-grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'LaTeX 문법 검사기 | 교정 LaTeX 파일| Trinka AI 기반' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "LaTeX용 Trinka 교정 파일은 클릭 한 번으로 LaTeX 파일의 문법을 검사할 수 있는 솔루션으로, 자동 문법 검사 기능으로 시간을 절약할 수 있습니다." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Latex-banner.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/latex-grammar-checker' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../../assets/js/wisepop.js', function () { });
    }
    
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/joaE-2djPGE" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
